import styled from '@emotion/styled';
import { boxSizes, colors, colorVariables, fontSizes, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const ContactFormContainer = styled.div`
    height: calc(100% - 64px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const ContactFormContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 ${gutterSizes.large};

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE & Edge */

    &::-webkit-scrollbar {
        display: none;
    }

    & > h2 {
        margin-bottom: ${gutterSizes.xlarge};
    }
`;

export const ContactFormButtonsContainer = styled.div`
    border-top: 1px solid ${colorVariables.borderLight};
    padding: ${gutterSizes.large};
`;

export const PrivacyNotice = styled.div`
    font-size: ${fontSizes.msmall};
    color: ${colors.darkGrey};
    margin-bottom: ${gutterSizes.large};

    a {
        color: ${colors.darkGrey};
        font-size: ${fontSizes.msmall};
        text-decoration: underline;
        text-decoration-color: ${colors.darkGrey};
        cursor: pointer;
    }
`;

export const ContactFormButtons = styled.div`
    display: flex;
    gap: ${gutterSizes.base};

    button {
        flex: 1;
        height: ${boxSizes.boxHeight48};
        font-weight: ${fontWeights.bold};
        border-radius: ${boxSizes.borderRadius};
        transition: background-color 0.3s ease;

        &:hover {
            opacity: 0.9;
        }
    }
`;

export const NextButton = styled.button<{ disabled: boolean }>`
    background-color: ${props => props.disabled ? colors.surfaceHover : colors.gtGreen};
    border: none;
    color: ${props => props.disabled ? colorVariables.textSecondary : colorVariables.textHighlightedDescription};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`

export const BackButton = styled.button`
    background-color: ${colors.white};
    border: 1px solid ${colorVariables.textHighlightedDescription};
    color: ${colorVariables.textHighlightedDescription};
    cursor: pointer;
`

export const CheckboxContainer = styled.div`
    margin: ${gutterSizes.large} 0;
    padding: ${gutterSizes.base} 0;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    gap: ${gutterSizes.base};
`;

export const CheckboxInput = styled.input`
    width: ${boxSizes.boxHeight20};
    height: ${boxSizes.boxHeight20};
    margin: 0;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: ${colors.blade};
    
    &:checked {
        background-color: ${colors.blade};
        border-color: ${colors.blade};
    }
`;

export const CheckboxText = styled.span`
    font-weight: ${fontWeights.normal};
    color: ${colors.darkGrey};
    line-height: 1.4;
    flex: 1;
`;
